import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useEffect, useState } from "react";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";

export default function GlobalSettings(props) {
  const [open, setOpen] = useState(false);
  const [powerSaver, setPowerSaver] = useState(
    localStorage.getItem("powerSaver") === "true"
  );
  const [noBark, setNoBark] = useState(
    localStorage.getItem("noBark") === "true"
  );
  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (save) => {
    setOpen(false);
    if (save) {
      localStorage.setItem("powerSaver", powerSaver);
      localStorage.setItem("noBark", noBark);
    } else {
      props.onClose();
    }
    document.location.reload();
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Global Settings</DialogTitle>
        <DialogContent>
          {/*<DialogContentText>Please enter your device UUID:</DialogContentText>*/}
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={powerSaver}
                  onChange={(e) => {
                    setPowerSaver(e.target.checked);
                  }}
                />
              }
              label="Power Saver"
            />
          </FormGroup>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={noBark}
                  onChange={(e) => {
                    setNoBark(e.target.checked);
                  }}
                />
              }
              label="Use Beep Not Bark"
            />
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)}>Cancel</Button>
          <Button onClick={() => handleClose(true)}>Save</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
